import { setDecompositionTreeValueFilter as setDecompositionTreeValueFilterDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    valueFilter?: string,
}

export const applyDecompositionTreeValueFilter = ({
    valueFilter,
    eventEmitter,
}: Props) => {
    setDecompositionTreeValueFilterDiagram(valueFilter);
    eventEmitter.emit(Event.applyFilter);
};
